module.exports = __webpack_public_path__ + "img/mysql.1aa6388e.png";